

























/* Created- 16 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { IssueTailorPaymentDTO } from "../../Generated/ParticaAPI";
import { DateUtils } from "../../BusinessServices/dateutils";
@Component(
	{
		name: "StreamTailorPayments"
	})
export default class StreamTailorPayments extends Vue {
	@Prop() private data: IssueTailorPaymentDTO[];
	private search: string = "";
	private headers: any = [
		{ text: "Created", value: "created" },
		{ text: "Tailor", value: "tailor" },
		{ text: "Issue", value: "issue" },
		{ text: "Stream", value: "stream" },
		{ text: "Subscriber", value: "subscriber" },
		{ text: "Tailoring", value: "tailoringType" },
		{ text: "Amount", value: "amount" },
	];
	private getFormat(date: Date) {
		if (DateUtils.CompareDate(date, new Date("0001-01-01T00:00:00Z"))) {
			return "Unknown";
		}
		return date.toDateString();
	}
}
